export function getAbsoluteOffsetY(element: Element | null) {
  let currentElement = element;
  let currentOffset = 0;
  while (currentElement !== null) {
    // Legacy cast - may or may not be necessary
    // eslint-disable-next-line replo/no-as-cast
    currentOffset += (currentElement as HTMLElement).offsetTop ?? 0;
    // Legacy cast - may or may not be necessary
    // eslint-disable-next-line replo/no-as-cast
    currentElement = (currentElement as HTMLElement).offsetParent;
  }
  return currentOffset;
}
